(function(){
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var d=document,ZOOM_END=.4,BREAK_START=.4,ZMAX=1.5;
  function clamp(v){return v<0?0:v>1?1:v}
  function rnd(a,b){return a+Math.random()*(b-a)}

  function Hero(el){
    this.el=el;
    this.sticky=el.querySelector('.ig-hero__sticky');
    this.cam=el.querySelector('.ig-hero__cam');
    this.media=this.cam.querySelector('video,img');
    this.box=el.querySelector('.ig-hero__shards');
    this.S=Math.min(parseFloat(el.dataset.zoom)||ZMAX,ZMAX);
    this.fx=(parseFloat(el.dataset.fx)||51)/100;
    this.fy=(parseFloat(el.dataset.fy)||52)/100;
    this.broken=false;this.painted=false;
    this.layout();
  }
  Hero.prototype.layout=function(){
    var w=this.sticky.clientWidth,h=this.sticky.clientHeight;
    this.W=w;this.H=h;
    var prev=this.cam.style.transform;this.cam.style.transform='none';
    var sr=this.sticky.getBoundingClientRect(),r=this.media.getBoundingClientRect();
    this.cam.style.transform=prev;
    this.base={x:r.left-sr.left,y:r.top-sr.top,w:r.width,h:r.height};
    this.F={x:this.base.x+this.base.w*this.fx,y:this.base.y+this.base.h*this.fy};
    this.C={x:w/2,y:h/2};
    this.buildShards();
    this.painted=false;
  };
  Hero.prototype.buildShards=function(){
    var box=this.box,w=this.W,h=this.H;box.innerHTML='';
    var cols=w<700?4:7,rows=w<700?6:4,xs=[0],ys=[0],i,j;
    for(i=1;i<cols;i++)xs.push(Math.round(w*i/cols+rnd(-.22,.22)*w/cols));xs.push(w);
    for(j=1;j<rows;j++)ys.push(Math.round(h*j/rows+rnd(-.22,.22)*h/rows));ys.push(h);
    var dpr=Math.min(window.devicePixelRatio||1,2);this.dpr=dpr;
    this.shards=[];
    for(j=0;j<rows;j++)for(i=0;i<cols;i++){
      var x=xs[i],y=ys[j],sw=xs[i+1]-x,sh=ys[j+1]-y;
      var c=d.createElement('canvas');c.width=Math.ceil(sw*dpr);c.height=Math.ceil(sh*dpr);
      c.style.width=sw+'px';c.style.height=sh+'px';c.style.transformOrigin='50% 50%';
      box.appendChild(c);
      var cx=x+sw/2-this.C.x,cy=y+sh/2-this.C.y,dist=Math.sqrt(cx*cx+cy*cy)||1;
      this.shards.push({c:c,x:x,y:y,w:sw,h:sh,
        dx:cx/dist,dy:cy/dist,dist:dist,
        push:rnd(.9,1.5),z:rnd(180,620),
        rx:rnd(-70,70),ry:rnd(-70,70),rz:rnd(-40,40),delay:Math.min(.25,(1-dist/Math.max(w,h))*.2+rnd(0,.06))});
    }
  };
  Hero.prototype.paint=function(){
    var m=this.media;
    if(m.tagName==='IMG'&&!(m.complete&&m.naturalWidth))return;
    if(m.tagName==='VIDEO'&&m.readyState<2)return;
    var dpr=this.dpr,S=this.S,W=this.W,H=this.H;
    var mc=d.createElement('canvas');mc.width=Math.ceil(W*dpr);mc.height=Math.ceil(H*dpr);
    var ctx=mc.getContext('2d');
    ctx.fillStyle='#050505';ctx.fillRect(0,0,mc.width,mc.height);
    var tx=this.C.x-this.F.x*S,ty=this.C.y-this.F.y*S;
    try{ctx.drawImage(m,(tx+this.base.x*S)*dpr,(ty+this.base.y*S)*dpr,this.base.w*S*dpr,this.base.h*S*dpr)}catch(e){return}
    this.shards.forEach(function(s){
      s.c.getContext('2d').drawImage(mc,s.x*dpr,s.y*dpr,s.w*dpr,s.h*dpr,0,0,s.c.width,s.c.height);
    });
    this.painted=true;
  };
  Hero.prototype.update=function(){
    var r=this.el.getBoundingClientRect(),dist=r.height-this.H;
    var p=dist>0?clamp(-r.top/dist):0;
    var e=clamp(p/ZOOM_END);
    var s=Math.pow(this.S,e);
    var tx=this.F.x+(this.C.x-this.F.x)*e-this.F.x*s,ty=this.F.y+(this.C.y-this.F.y)*e-this.F.y*s;
    this.cam.style.transform='translate3d('+tx.toFixed(2)+'px,'+ty.toFixed(2)+'px,0) scale('+s.toFixed(4)+')';
    this.el.style.setProperty('--e',e.toFixed(4));
    this.el.style.setProperty('--mx',(48+e*110).toFixed(1)+'%');
    this.el.style.setProperty('--my',(52+e*110).toFixed(1)+'%');
    var b=clamp((p-BREAK_START)/(1-BREAK_START));
    var on=b>0;
    if(on&&!this.broken){if(!this.painted||this.media.tagName==='VIDEO')this.paint()}
    if(on!==this.broken){this.broken=on;this.el.classList.toggle('is-break',on)}
    this.sticky.style.pointerEvents=b>.4?'none':'';
    if(!on)return;
    this.shards.forEach(function(sh){
      var k=clamp((b-sh.delay)/(1-sh.delay));k=k*k*(3-2*k);
      var mv=k*sh.push*(sh.dist*.9+260);
      var t='translate3d('+(sh.x+sh.dx*mv).toFixed(1)+'px,'+(sh.y+sh.dy*mv).toFixed(1)+'px,'+(k*sh.z).toFixed(1)+'px) rotateX('+(k*sh.rx).toFixed(1)+'deg) rotateY('+(k*sh.ry).toFixed(1)+'deg) rotateZ('+(k*sh.rz).toFixed(1)+'deg)';
      sh.c.style.transform=t;
      sh.c.style.opacity=(1-clamp((k-.4)/.5)).toFixed(3);
    });
  };

  var heroes=[],ticking=false;
  function frame(){ticking=false;heroes.forEach(function(h){h.update()})}
  function req(){if(!ticking){ticking=true;requestAnimationFrame(frame)}}
  function init(){
    heroes=[].slice.call(d.querySelectorAll('[data-ig="shatter"]')).map(function(el){
      var h=new Hero(el);
      var m=h.media;
      if(m.tagName==='IMG'){if(m.complete)h.paint();else m.addEventListener('load',function(){h.layout();h.paint();req()},{once:true})}
      return h;
    });
    if(!heroes.length)return;
    heroes.forEach(function(h){h.shards.forEach(function(s){s.c.style.transform='translate3d('+s.x+'px,'+s.y+'px,0)'})});
    req();
  }
  var rt;
  window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){heroes.forEach(function(h){h.layout();h.paint()});req()},120)});
  window.addEventListener('load',function(){heroes.forEach(function(h){h.layout();h.paint()});req()});
  d.addEventListener('scroll',req,{passive:true,capture:true});

  /* un geste (molette, glisser, fleche, clic) = l'animation joue seule et amene a la section suivante */
  var anim=false,lockUntil=0,ty0=null,tDone=false;
  function scroller(){var pw=d.querySelector('.page-wrapper');if(pw&&pw.scrollHeight>pw.clientHeight+2)return pw;return d.scrollingElement||d.documentElement}
  function hero(){for(var i=0;i<heroes.length;i++){var r=heroes[i].el.getBoundingClientRect();if(r.bottom>0&&r.top<window.innerHeight)return heroes[i]}return null}
  function target(h){var s=scroller(),sec=h.el.closest('.shopify-section'),nx=sec&&sec.nextElementSibling;
    if(nx)return s.scrollTop+nx.getBoundingClientRect().top;
    var r=h.el.getBoundingClientRect();return s.scrollTop+r.top+r.height-h.H}
  function glide(to){
    var s=scroller(),from=s.scrollTop;if(Math.abs(to-from)<2)return false;
    var D=Math.min(1150,Math.max(650,Math.abs(to-from)/window.innerHeight*1400)),t0=null,h=d.documentElement,sb=s.style.scrollBehavior,hb=h.style.scrollBehavior;
    s.style.scrollBehavior='auto';h.style.scrollBehavior='auto';anim=true;
    function step(t){if(t0==null)t0=t;var k=Math.min(1,(t-t0)/D),e=k<.5?4*k*k*k:1-Math.pow(-2*k+2,3)/2;
      s.scrollTop=from+(to-from)*e;
      if(k<1)requestAnimationFrame(step);else{anim=false;lockUntil=Date.now()+450;s.style.scrollBehavior=sb;h.style.scrollBehavior=hb;req()}}
    requestAnimationFrame(step);return true;
  }
  function decide(dir){
    var h=hero();if(!h)return false;
    var s=scroller(),z=s.scrollTop,T=target(h);
    if(dir>0&&z<T-2)return glide(T);
    if(dir<0&&z>2&&z<=T+2)return glide(0);
    return false;
  }
  function busy(e){if(anim||Date.now()<lockUntil){if(hero()||anim){e.preventDefault();return true}}return false}
  window.addEventListener('wheel',function(e){
    if(!heroes.length||e.ctrlKey)return;if(busy(e))return;
    if(Math.abs(e.deltaY)<3)return;
    if(decide(e.deltaY>0?1:-1))e.preventDefault();
  },{passive:false,capture:true});
  window.addEventListener('touchstart',function(e){ty0=e.touches[0].clientY;tDone=false},{passive:true,capture:true});
  window.addEventListener('touchmove',function(e){
    if(!heroes.length||ty0==null)return;
    if(anim){e.preventDefault();return}
    if(tDone){if(hero())e.preventDefault();return}
    var dy=ty0-e.touches[0].clientY;if(Math.abs(dy)<10)return;
    if(decide(dy>0?1:-1)){tDone=true;e.preventDefault()}
  },{passive:false,capture:true});
  window.addEventListener('keydown',function(e){
    if(!heroes.length)return;var t=e.target,tag=t&&t.tagName;
    if(tag==='INPUT'||tag==='TEXTAREA'||tag==='SELECT'||(t&&t.isContentEditable))return;
    var k=e.key,dir=(k==='ArrowDown'||k==='PageDown'||(k===' '&&!e.shiftKey))?1:(k==='ArrowUp'||k==='PageUp'||(k===' '&&e.shiftKey))?-1:0;
    if(!dir)return;if(anim){e.preventDefault();return}
    if(decide(dir))e.preventDefault();
  },true);
  d.addEventListener('click',function(e){
    var h=hero();if(!h||anim)return;
    if(!h.el.contains(e.target)||e.target.closest('a:not(.ig-hero__scroll),button:not(.ig-hero__scroll),input,label'))return;
    if(decide(1))e.preventDefault();
  });
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',init);else init();
  d.addEventListener('shopify:section:load',function(){setTimeout(init,60)});
})();
